/**
 * @file starterChips.ts
 * @description Shared preset question chips for the credentialing chatbot.
 *              Used by the public CredentialingChatWidget and the cache
 *              warm-up cron to keep answers in sync.
 * @author William Donaldson
 * @last_modified 2026-04-16
 */

// WHY SHARED: The cache warm-up cron must target the exact same question
// text as the widget sends. Defining them once prevents silent drift
// where the cron warms different phrasing than users actually click.
export const STARTER_CHIPS = [
  "What do I need to enroll with UHC?",
  "How long does Aetna credentialing take?",
  "How do I set up CAQH ProView?",
  "Medicare enrollment requirements",
];
